import React, { useEffect } from 'react';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './TicketsPage.css';

const TicketsPage = ({ darkMode, toggleDarkMode }) => {
  useEffect(() => {
    // Cargar el script de HubSpot
    const script = document.createElement('script');
    script.src = 'https://js-eu1.hsforms.net/forms/embed/25730550.js';
    script.defer = true;
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);



  return (
    <>
      <SEO 
        title="Soporte Técnico | E-ASY"
        description="Obtén soporte técnico especializado para tus proyectos. Nuestro equipo está disponible 24/7 para resolver cualquier consulta o problema."
        keywords="soporte técnico, ayuda, tickets, consultas, problemas, asistencia"
        canonical="https://e-asy.es/tickets"
      />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className={`tickets-page ${darkMode ? 'dark' : 'light'}`}>
        {/* Hero Section */}
        <section className="tickets-hero">
          <div className="tickets-hero-content">
            <div className="tickets-hero-text">
              <h1 className="tickets-hero-title">Soporte Técnico</h1>
              <p className="tickets-hero-subtitle">
                Nuestro equipo de expertos está aquí para ayudarte con cualquier consulta, problema técnico o solicitud de soporte. Respuesta garantizada en menos de 24 horas.
              </p>
              <div className="tickets-hero-stats">
                <div className="hero-stat">
                  <div className="hero-stat-number">24/7</div>
                  <div className="hero-stat-label">Disponibilidad</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">&lt;24h</div>
                  <div className="hero-stat-label">Tiempo Respuesta</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">98%</div>
                  <div className="hero-stat-label">Satisfacción</div>
                </div>
              </div>
            </div>
            <div className="tickets-hero-video">
              <div className="tickets-hero-visual">
                                 <img
                   src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                   alt="Soporte técnico especializado"
                   className="tickets-hero-image"
                 />
              </div>
            </div>
          </div>
        </section>

                 {/* Main Content */}
         <main className="tickets-main">
           <div className="tickets-content">
             <div className="tickets-layout">
               {/* Form Section */}
               <section className="tickets-form-section">
                 <div className="form-header">
                   <h2 className="form-title">Crear Ticket de Soporte</h2>
                   <p className="form-subtitle">
                     Completa el formulario con los detalles de tu consulta. Nuestro equipo te responderá lo antes posible.
                   </p>
                 </div>
                 
                 <div className="hubspot-form-container">
                   <iframe 
                     src="https://share-eu1.hsforms.com/1n-Wy2taSR8ml-XuJJrFlgAfbhti"
                     width="100%"
                     height="900"
                     frameBorder="0"
                     title="Formulario de Soporte Técnico"
                     style={{ border: 'none', borderRadius: '12px' }}
                   ></iframe>
                 </div>
               </section>

               {/* Info Section */}
               <section className="tickets-info-section">
                 <div className="info-header">
                   <h2 className="info-title">Otras Formas de Contacto</h2>
                   <p className="info-subtitle">
                     Además del formulario, puedes contactarnos a través de estos canales:
                   </p>
                 </div>

                 <div className="support-methods">
                   <div className="support-method">
                     <div className="method-icon">
                       <div className="ticket-graphic"></div>
                     </div>
                     <div className="method-content">
                       <h3 className="method-title">Sistema de Tickets</h3>
                       <div className="method-value">Prioridad Alta</div>
                       <p className="method-description">
                         Para problemas técnicos urgentes y consultas complejas. Respuesta garantizada en menos de 24 horas.
                       </p>
                     </div>
                   </div>

                   <div className="support-method">
                     <div className="method-icon">
                       <div className="phone-graphic"></div>
                     </div>
                     <div className="method-content">
                       <h3 className="method-title">Teléfono</h3>
                       <div className="method-value">
                         <a href="tel:+34822685012">+34 822 68 50 12</a>
                       </div>
                       <p className="method-description">
                         Lun-Vie 9:00 - 17:00. Para consultas urgentes fuera de horario, deja un mensaje.
                       </p>
                     </div>
                   </div>

                   <div className="support-method">
                     <div className="method-icon">
                       <div className="email-graphic"></div>
                     </div>
                     <div className="method-content">
                       <h3 className="method-title">Email</h3>
                       <div className="method-value">soporte@e-asy.es</div>
                       <p className="method-description">
                         Para consultas no urgentes y documentación técnica. Respuesta en 24-48 horas.
                       </p>
                     </div>
                   </div>
                 </div>

                 <div className="support-benefits">
                   <h3 className="benefits-title">¿Por qué elegir nuestro soporte?</h3>
                   <div className="benefits-list">
                     <div className="benefit-item">
                       <div className="benefit-icon">✓</div>
                       <div className="benefit-text">Equipo de expertos certificados</div>
                     </div>
                     <div className="benefit-item">
                       <div className="benefit-icon">✓</div>
                       <div className="benefit-text">Respuesta garantizada en menos de 24 horas</div>
                     </div>
                     <div className="benefit-item">
                       <div className="benefit-icon">✓</div>
                       <div className="benefit-text">Soporte en español y inglés</div>
                     </div>
                     <div className="benefit-item">
                       <div className="benefit-icon">✓</div>
                       <div className="benefit-text">Seguimiento completo hasta resolución</div>
                     </div>
                   </div>
                 </div>
               </section>
             </div>
           </div>
         </main>
      </div>
      <Footer darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </>
  );
};

export default TicketsPage; 